import React from "react";
import * as omnimap from "../../../../../api/omnimap/omnimapActions";
import * as CallBackFunctions from "./functions/callBackFunctions";
import * as Variable from "./Variable/v";

import maatregelenSvg from "../../../../../content/images/table/XMLID_3_.svg";
import $ from "jquery";
import * as CommonFunctions from "../common/commonFunctions";
import ColumnList from "../../../../common/componet-jsons/column-list-catalog.json";
import * as GC from "../../../../common/common";
import { CONSTS } from "../../../../common/const";

class Table extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      columnList: [],
      columnListPure: [],
      columnOrderIdentification: "",
      columnOrderReference: "",
    };
  }

  reloadData(page_number, ids, short_type, direction, field, content = []) {
    var model;

    this.fillTable((model = []), (page_number = 1));
    this.fillFilterColumns();
  }
  fillFilterColumns() {
    omnimap
      .GetUserRolesAction(1, 100, window.$catalog_users_token)
      .then((result) => {
        CallBackFunctions.FillFilterColumnsCallBack(
          "user-gebruikersrollen",
          result
        );
      });
    // var that = this;
    // var model = {
    //   definitions: [process.env.REACT_APP_CATALOG_M_UNITS],
    // };
    // $.each(window.$catalog_users_columnList, function (index, data) {
    //   if (data.id !== "" && data.filter === true) {
    //     omnimap
    //       .FillFilterColumnsAction(model, data.id, window.$catalog_users_token)
    //       .then((result) => {
    //         CallBackFunctions.FillFilterColumnsCallBack(data, result);
    //       })
    //       .catch((error) => {
    //         console.log(error);
    //       });
    //   }
    // });
  }
  fillTable(model, page_number) {
    var that = this;
    window.$catalog_users_lastUsedTableFilter = model;

    window.$catalog_users_treeChangeStatus = false;
    window.$catalog_users_scroll_change = false;

    omnimap
      .GetAllUsersAction(1, 100, "", "", "", "", window.$catalog_users_token)
      .then((result) => {
        CallBackFunctions.FillTableCallBack(
          result,
          page_number,
          window.$catalog_users_columnListPure
        );
      });
  }

  addContentAndFillTable(key, value) {
    var hasRow = $.grep(
        window.$catalog_users_filterContent,
        function (v) {
          return v.key === key;
        }
    );
    /*var hasRow = window.$catalog_users_filterContent.filter(
      (v) => v.key === key
    );*/

    if (hasRow.length > 0) {
      window.$catalog_users_filterContent = $.grep(
        window.$catalog_users_filterContent,
        function (value) {
          return value !== hasRow[0];
        }
      );
    }
    if (value !== null) {
      var contentModel = {
        key: key,
        value: value,
      };
      window.$catalog_users_filterContent.push(contentModel);
    }

    /**
     * *omnimap'teki yapıya göre username ve email aynı alanda arama yapılıyor
     * * bu yüzden ya username yada email araması yapılması gerekiyor
     */
    if (
      window.$catalog_users_filterContent.length > 0 &&
      key !== "user-gebruikersrollen" &&
      key !== "user-organisatie"
    ) {
      var test = window.$catalog_users_filterContent.filter(
        (x) => x.key !== key
      );
      if (test.length > 0) {
        // burada username yada email alanlarından sadece birtanesi seçilmesi zorunluğu sağlanıyor.
        document.getElementById(test[test.length - 1].key).value = "";
      }
    }

    let role = window.$catalog_users_filterContent.find(
      (x) => x.key === "user-gebruikersrollen"
    );
    let organisatie = window.$catalog_users_filterContent.find(
      (x) => x.key === "user-organisatie"
    );
    //only name and email filter
    let filter = window.$catalog_users_filterContent.find(
      (x) => x.key !== "user-gebruikersrollen" && x.key !== "user-organisatie"
    );
    omnimap
      .GetAllUsersAction(
        1,
        100,
        filter && filter !== undefined ? filter.value : "",
        organisatie && organisatie !== undefined ? organisatie.value : "",
        "",
        role && role !== undefined ? role.value : "",
        window.$catalog_users_token
      )
      .then((result) => {
        CallBackFunctions.FillTableCallBack(result, 1, window.$catalog_users_columnListPure);
      });
  }

  searchFilterColumns(key, searchId) {
    if (searchId === "user-organisatie") {
      omnimap
        .GetOrganisationsAction(1, 100, window.$catalog_users_token)
        .then((result) => {
          CallBackFunctions.SearchFilterColumnsCallBack(
            "user-organisatie",
            result
          );
        });
    } else if (searchId === "user-gebruikersrollen") {
      omnimap
        .GetUserRolesAction(1, 100, window.$catalog_users_token)
        .then((result) => {
          CallBackFunctions.SearchFilterColumnsCallBack(
            "user-gebruikersrollen",
            result
          );
        });
    } else {
      omnimap
        .GetAllUsersAction(1, 100, key, "", "", "", window.$catalog_users_token)
        .then((result) => {
          var unique = [];
          if (searchId === "user-alias") {
            /**
             * * sql'deki gibi dizi içerisinde distinct mantığı ile
             * * tekrar eden satırlar tekleştiriliyor.
             */
            unique = [
              ...new Set(result.data && result.data.map((item) => item.alias)),
            ];
          } else if (searchId === "user-email") {
            /**
             * * sql'deki gibi dizi içerisinde distinct mantığı ile
             * * tekrar eden satırlar tekleştiriliyor.
             */
            unique = [
              ...new Set(result.data && result.data.map((item) => item.email)),
            ];
          }

          CallBackFunctions.SearchFilterColumnsCallBack(searchId, unique);
        });
    }
  }

  GetActionsOfRow(rowIds) {
    CallBackFunctions.GetActionsOfRowCallback();
  }

  /*** ---PROPSTAN GELEN TREE VERİSİ İÇERİSİNDE TIKLANAN Lİ'NİN TÜM ALT DALLARINDAKİ İDLERİ GETİRİR--- ***/
  treeParser = (data, beheereenheid) => {
    const that = this;
    data.forEach(function (element) {
      if (element.parentfolder === beheereenheid) {
        window.$catalog_users_result.push(element.id);
        if (element.children.length > 0) {
          that.treeParser(element.children, element.id);
        }
      } else if (element.children && element.children.length > 0) {
        that.treeParser(element.children, beheereenheid);
      }
    });
  };
  componentWillMount() {
    $('#example').DataTable().destroy();
  }


  componentDidUpdate(prevProps, prevState) {
    const that = this;
    if (!that.props.location.state) {
      if (that.props.location.isDidUpdate !== prevProps.location.isDidUpdate) {
        var model = {
          content: [],
          definitions: [process.env.REACT_APP_CATALOG_M_UNITS],
        };
        // that.setState({ lastUsedTableFilter: model });
        window.$catalog_users_lastUsedTableFilter = model;

        that.reloadData(1);
        document.getElementById("tree-parent-id").setAttribute("value", "");

        var treeClass = document.querySelector(".tree li.open.act");
        var treeDivClass = document.querySelector(".tree li div.open.act");
        if (treeClass !== null) {
          treeClass.removeAttribute("class");
        }
        if (treeDivClass !== null) {
          treeDivClass.classList.remove("open");
          treeDivClass.classList.remove("act");
        }
      } else {
        $("#cover-spin").hide(0);
      }
    } else if (that.props.location.state && prevProps.location.state) {
      if (
        that.props.location.state.isDidUpdate !==
        prevProps.location.state.isDidUpdate
      ) {
        if (that.props.location.state.isDidUpdate == "0038") {
          var model = {
            content: [],
            definitions: [process.env.REACT_APP_CATALOG_M_UNITS],
          };
          // that.setState({ lastUsedTableFilter: model });
          that.reloadData(1);
        } else {
          window.$catalog_users_result = [];
          window.$catalog_users_result.push(that.props.location.state.id);
          this.treeParser(
            that.props.location.state.TreeList,
            that.props.location.state.id
          );
          if (that.props.location.state.treeLocation !== "modal") {
            that.reloadData(1, window.$catalog_users_result);
          }
        }
      }
      //* sayfa f5 ile yenilendiğinde prev props:
      //* temizlenmediğinden dolayı veri gelmemesi sorunu için bu kod çalıştırılıyor.
      else if (window.performance) {
        if (performance.navigation.type == 1) {
          if (that.props.location.state.isDidUpdate == "0038") {
            var model = {
              content: [],
              definitions: [process.env.REACT_APP_CATALOG_M_UNITS],
            };
            // that.setState({ lastUsedTableFilter: model });
            that.reloadData(1);
          } else {
            window.$catalog_users_result = [];
            window.$catalog_users_result.push(that.props.location.state.id);
            this.treeParser(
              that.props.location.state.TreeList,
              that.props.location.state.id
            );
            if (that.props.location.state.treeLocation !== "modal") {
              that.reloadData(1, window.$catalog_users_result);
            }
          }
        } else {
          //alert("This page is not reloaded");
        }
      }
    } else {
      window.$catalog_users_result = [];
      window.$catalog_users_result.push(that.props.location.state.id);
      this.treeParser(
        that.props.location.state.TreeList,
        that.props.location.state.id
      );
      if (that.props.location.state.treeLocation !== "modal") {
        that.reloadData(1, window.$catalog_users_result);
      }
      $("#cover-spin").hide(0);
    }
  }

  async componentDidMount() {
    var that = this;

    /***************************************************************************************/
    /**FREE FORMAT */
    var tableHeaderItems;
    var userColumnResult = await omnimap.GetFreeFormatByIdAction(
      CONSTS.USER_ID_STORE
    );
    // userda column sort id'si varmı ?
    if (userColumnResult.meta.total_found == 0) {
      var user = window.localStorage.getItem("accessToken");
      window.$mm_management_units_column_order_users.client_identification =
        CONSTS.USER_ID_STORE;
      window.$mm_management_units_column_order_users.code =
        CONSTS.USER_ID_STORE;
      window.$mm_management_units_column_order_users.data.users.push({
        user_id: user.identification,
        id_stores: {
          table_column_order: GC.uuidv4(),
        },
      });
      omnimap
        .GetFreeFormatAction(
          "",
          "POST",
          window.$mm_management_units_column_order_users
        )
        .then(() => {
          // GC.sleep(1500).then(() => this.fillTable());
        });
    }
    //userda column sort id'si var sa else geç
    else {
      let result = await omnimap.GetFreeFormatByIdAction(
        CONSTS.COLUMN_ORDER_CATALOG_GEBRUIKERSBEHEER
      );

      // bu sayfanın column sort'u var mı?
      if (result.meta.total_found == 0) {
        window.$catalog_users_column_order_post_model.client_identification =
          CONSTS.COLUMN_ORDER_CATALOG_GEBRUIKERSBEHEER;
        window.$catalog_users_column_order_post_model.code =
          CONSTS.COLUMN_ORDER_CATALOG_GEBRUIKERSBEHEER;

        omnimap
          .GetFreeFormatAction(
            "",
            "POST",
            window.$catalog_users_column_order_post_model
          )
          .then(() => {
            window.location.reload();
          });
      }
      // bu sayfanın column sort'u varsa else'e geç
      else {
        //burada sayfanın column sortları listenelinr ve table th sıralaması yapılır

        let result = await omnimap.GetFreeFormatByIdAction(
          CONSTS.COLUMN_ORDER_CATALOG_GEBRUIKERSBEHEER,
          "GET"
        );

        await this.setState({
          columnOrderIdentification: result.data[0].identification,
          columnOrderReference: result.data[0].reference,
        });

        result = await result.data[0].data.table_sorting.find(
          (x) => x.name === "catalog>gebruikersbeheer"
        );

        tableHeaderItems = await result.column_list.map((item, index) =>
          item === "checkbox" ? (
            <th className="sorting_disabled">
              <span className="checkAll" />
              <span className="checkNone" style={{ display: "none" }} />
            </th>
          ) : item === "active" ? (
            <th className="sorting_disabled" style={{ width: "1%" }}>
              <div id="beheer-short-table">
                <div id="beheer-svg" className="maatregelen-svg"></div>
                <div id="beheer-snowflake" className="snowflake"></div>
              </div>
            </th>
          ) : (
            <th key={item}>{item}</th>
          )
        );
        await this.setState({
          columnList: tableHeaderItems,
        });
        window.$catalog_users_columnListPure = result;
      }
    }
    /***************************************************************************************/

    if (window.$catalog_users_token == null) {
      window.$catalog_users_token = GC.GetToken().then((token) => {
        window.$catalog_users_token = token;
        this.reloadData(1);
      });
    } else that.reloadData(1);

    ColumnList.forEach(function (item) {
      if (item.name == "catalog>users") {
        window.$catalog_users_columnList = item["column-list"];
      }
    });
    var table = $("#example").DataTable({
      order: [],
      ordering: true,
      orderCellsTop: true,
      fixedHeader: true,
      searching: false,
      paging: false,
      scrollX: true, //"500px",

      scrollCollapse: true,
      scrollY: "calc(100vh - 330px)",

      dom: '<"top"if>t<"bottom"pr><"clear">',
      info: true,
      destroy: true,
      infoCallback: function (settings, start, end, max, total, pre) {
        return (
          '<span class="select-item"></span>' +
          '<span class="total_right"><span id="total-rows" class="total">' +
          end +
          "</span> geselecteerd </span>"
        );
      },
      language: {
        paginate: {
          previous: "Eerste",
          next: "Laatste",
        },
        select: {
          rows: '<span class="items">%d </span>items van&nbsp;', //'<span class="items">%d </span>items van&nbsp;',
        },
      },
      columnDefs: [
        {
          targets: [0],
          data: null,
          defaultContent: "",
          orderable: false,
          className: "select-checkbox",
        },
      ],
      select: {
        style: "multi+shift",
        selector: "tr",
      },
      // Disable sorting on the sorting_disabled class
      aoColumnDefs: [
        {
          bSortable: false,
          aTargets: ["sorting_disabled"],
        },
      ],
      colReorder: {
        fixedColumnsLeft: 1
      },
      stateSave: true,
      stateSaveCallback: (settings, data) => {
        let result = CallBackFunctions.TableColumnChangeHandler(
          settings,
          data,
          that.state.columnOrderIdentification,
          that.state.columnOrderReference,
          CONSTS.COLUMN_ORDER_CATALOG_GEBRUIKERSBEHEER
        );
        window.$catalog_users_columnListPure = result;
      },
    });
    table.columns().iterator("column", function (ctx, idx) {
      if (
        window.$catalog_users_columnListPure.column_list[idx] === "checkbox" ||
        window.$catalog_users_columnListPure.column_list[idx] === "active"
      ) {
      } else {
        $(table.column(idx).header()).append('<span class="sort-icon"/>');
      }
    });
    var lastScrollLeft = 0;
    var lastScrollControl = 0.33;
    var buffer = 0.33; // # of pixels from bottom of scroll to fire your function. Can be 0

    $(".dataTables_scrollBody").scroll(function () {
      var documentScrollLeft = $(".dataTables_scrollBody").scrollLeft();
      if (window.$catalog_users_scroll_change) {
        if (
          $(".dataTables_scrollBody").prop("scrollHeight") -
            $(".dataTables_scrollBody").scrollTop() <=
          $(".dataTables_scrollBody").height() + buffer
        ) {
          lastScrollControl = 0;
        }
      }
      if (window.$catalog_users_scroll_change) {
        if (
          $(".dataTables_scrollBody").prop("scrollHeight") -
            $(".dataTables_scrollBody").scrollTop() <=
          $(".dataTables_scrollBody").height() + buffer
        ) {
          lastScrollControl = 0;
        }
      }
      if (lastScrollLeft == documentScrollLeft + lastScrollControl) {
        if (window.$catalog_users_scroll_change) {
          if (
            $(".dataTables_scrollBody").prop("scrollHeight") -
              $(".dataTables_scrollBody").scrollTop() <=
            $(".dataTables_scrollBody").height() + buffer
          ) {
            if (document.getElementById("tableSide").className !== "d-none") {
              if (
                `/${this.baseURI.split("/")[3]}/${
                  this.baseURI.split("/")[4]
                }` === that.props.location.pathname &&
                window.$catalog_users_total_row > 100
              ) {
                $("#cover-spin").show(0);
                window.$catalog_users_page_number++;
                that.fillTable(
                  window.$catalog_users_lastUsedTableFilter,
                  window.$catalog_users_page_number
                );
              }
            } else window.$catalog_users_scroll_change = true;
          }
        }
      }
    });
    $(document).on("click", "#mappen_beheren", function () {
      $("#mappen_beheren_modal").modal("show");
    });
    $(document).on("click", "#user-verwijderen", function () {
      if (window.$catalog_users_selectedIds == 0) {
        alert("rows not selected");
      } else {
        $("#user-delete-modal").modal("show");
      }
    });

    /*** SETUP - ADD A TEXT INPUT TO EACH FOOTER CELL ***/
    $("#example thead tr").clone(true).appendTo("#example thead");
    $("#example thead tr th").removeClass("sorting_asc");

    $(table.table().header()).addClass("scrollabe-datatable");

    document.getElementsByClassName("scrollabe-datatable")[0].parentElement.id =
      "scrollabe-datatable-id";

    $("#scrollabe-datatable-id thead tr")
      .clone(true)
      .appendTo("#scrollabe-datatable-id thead");

    $("#scrollabe-datatable-id thead tr:eq(1) th").each(function (i) {
      var title = $(this).text();
      if (title) {
        var row = $.grep(window.$catalog_users_columnList, function (v) {
          return String(v.name).toLowerCase() === String(title).toLowerCase();
        });
        var rowId = row[0].id;
        if (row[0].filter == true) {
          $(this).html(
            '<input type="search" class="col-search" id="' + rowId + '" />'
          );
          $("input", this).on("keyup change", function () {
            if (table.column(i).search() !== this.value) {
              table.column(i).search(this.value).draw();
            }
          });
        } else {
          $(this).html("");
        }
      } else if (this.innerHTML.includes("checkAll")) {
        //$(this).html( '<div class="popup threedots" onclick="Popup()"><span class="popuptext" id="myPopup"><a class="maatregelen" href="#">Maatregelen</a><a class="locate" href="#">Beheer gebieden</a><a class="map" href="#">Toon op kaart</a><a class="trash-bin" href="#">Verwijderen</a></span></div>' );
        $(this).html(
          '<div class="popup threedots"><span class="popuptext" id="myPopup"></span></div>'
        );
      } else if (this.innerHTML.includes("snowflake")) {
        $(this).html(
          '<div class="refresh"> </div>' +
            /**popup filter1 */
            '<div class="filter-popup">' +
            '  <span class="popuptext" id="beheer-short-table-popup" ></span>' +
            "</div>"
        );
      } else {
        $(this).html("");
      }
    });

    // $("#scrollabe-datatable-id thead").on("click", "th", function () {
    //   var row_index = table.column(this).index();

    //   if (row_index != undefined && row_index != 0) {
    //     var nRow = $("#scrollabe-datatable-id thead tr")[0];
    //     if (
    //       this.childNodes[0].className != "popup threedots" &&
    //       this.childNodes[0].className != "col-search ui-autocomplete-input" &&
    //       this.childNodes[0].className != "refresh"
    //     ) {
    //       nRow.childNodes.forEach(function (indx) {
    //         if (indx.cellIndex != row_index) {
    //           indx.className = "sorting_disabled";
    //         }
    //       });

    //       if (row_index) {
    //         if (this.className == "sorting_disabled") {
    //           this.className = "sorting_asc";
    //           var row;
    //           $.each(window.$catalog_users_columnList, function (index, data) {
    //             if (data.row == row_index) {
    //               row = data;
    //             }
    //           });
    //           that.reloadData(
    //             1,
    //             window.$catalog_users_result,
    //             row.shortType,
    //             "ASCENDING",
    //             row.shortField,
    //             window.$catalog_users_filterContent
    //           );
    //         } else if (this.className == "sorting_asc") {
    //           this.className = "sorting_desc";
    //           var row;
    //           $.each(window.$catalog_users_columnList, function (index, data) {
    //             if (data.row == row_index) {
    //               row = data;
    //             }
    //           });
    //           that.reloadData(
    //             1,
    //             window.$catalog_users_result,
    //             row.shortType,
    //             "DESCENDING",
    //             row.shortField,
    //             window.$catalog_users_filterContent
    //           );
    //         } else if (this.className == "sorting_desc") {
    //           this.className = "sorting_asc";
    //           var row;
    //           $.each(window.$catalog_users_columnList, function (index, data) {
    //             if (data.row == row_index) {
    //               row = data;
    //             }
    //           });
    //           that.reloadData(
    //             1,
    //             window.$catalog_users_result,
    //             row.shortType,
    //             "ASCENDING",
    //             row.shortField,
    //             window.$catalog_users_filterContent
    //           );
    //         }
    //       }

    //       window.$catalog_users_page_number = 1;
    //     }
    //   }
    // });

    $("#example tbody").on("click", "tr", function () {
      if ($(".checkAll").attr("style") == "display: none;") {
        $(".checkNone, .checkAll").toggle();
      }
    });

    //** select all table
    $("#scrollabe-datatable-id").on("click", ".checkAll", function (e) {
      var table = $("#example").DataTable();
      table.rows().select();

      $(".checkNone, .checkAll").toggle();
    });

    //** unselect all table
    $("#scrollabe-datatable-id").on("click", ".checkNone", function (e) {
      var table = $("#example").DataTable();

      table.rows().deselect();
      $(".checkNone, .checkAll").toggle();
    });

    $("#example_filter input").addClass("search-input-table1");
    $(".search-input-table1").attr("placeholder", "search text");

    $("#example tbody").on("dblclick", "tr", function () {
      // var rowId = this.attributes[1].value;
      var rowId = $(this).attr("rowId");

      $.each(window.$catalog_users_Glist, function (index, data) {
        if (data.identification == rowId) {
          window.$catalog_users_selectedRow = data;
        }
      });

      // fillDetail();
      CommonFunctions.fillDetail();
      $("#tableSide").addClass("d-none");
      $("#detailSide").removeClass("d-none");
      $("#detailSide").attr("name", "dbl");
    });

    /*** ---OPTION TO ALLOW SELECTING ROWS BY CLICKING ON ROW BESIDES CHECKBOX--- ***/
    // $("#example tbody").on("click", "tr", function () {
    //   $(this).toggleClass("selected");
    // });

    $("#user-alias").autocomplete({
      source: window.$catalog_users_user_alias,
      select: function (event, ui) {
        that.addContentAndFillTable("user-alias", ui.item.value);
      },
      open: function (e, ui) {
        $(".ui-autocomplete").css(
          "top",
          $("ul.ui-autocomplete").cssUnit("top")[0] + 2
        );
      },
    });
    $("#user-email").autocomplete({
      source: window.$catalog_users_user_email,
      select: function (event, ui) {
        that.addContentAndFillTable("user-email", ui.item.value);
      },
      open: function (e, ui) {
        $(".ui-autocomplete").css(
          "top",
          $("ul.ui-autocomplete").cssUnit("top")[0] + 2
        );
      },
    });
    $("#user-gebruikersrollen").autocomplete({
      source: window.$catalog_users_gebruikersrollen,
      select: function (event, ui) {
        that.addContentAndFillTable("user-gebruikersrollen", ui.item.value);
      },
      open: function (e, ui) {
        $(".ui-autocomplete").css(
          "top",
          $("ul.ui-autocomplete").cssUnit("top")[0] + 2
        );
      },
    });
    $("#user-organisatie").autocomplete({
      source: window.$catalog_users_organisatie,
      select: function (event, ui) {
        that.addContentAndFillTable("user-organisatie", ui.item.value);
      },
      open: function (e, ui) {
        $(".ui-autocomplete").css(
          "top",
          $("ul.ui-autocomplete").cssUnit("top")[0] + 2
        );
      },
    });

    $("#user-alias").on("input", function () {
      // that.algemeenCode.length = 0;
      that.searchFilterColumns($(this).val(), this.id);
      // get the current value of the input field.
    });
    $("#user-email").on("input", function () {
      // that.algemeenCode.length = 0;
      that.searchFilterColumns($(this).val(), this.id);
      // get the current value of the input field.
    });

    $("#user-gebruikersrollen").on("input", function () {
      // that.algemeenCode.length = 0;
      that.searchFilterColumns($(this).val(), this.id);
      // get the current value of the input field.
    });
    $("#user-organisatie").on("input", function () {
      // that.algemeenCode.length = 0;
      that.searchFilterColumns($(this).val(), this.id);
      // get the current value of the input field.
    });

    $(".col-search").on("input", function (e) {
      if (this.value === "") {
        that.addContentAndFillTable($(this).attr("id"), null);
      }
    });

  /*  $(".col-search").on("click", function (e) {
      e.stopPropagation();
    });
    $(".col-search").keydown(function (e) {
      if (e.keyCode == 13) {
        e.preventDefault();
        return false;
      }
    });
*/
    function handleRefresh () {
      $("#cover-spin").show(0);
      $("#spinner").removeAttr("hidden");
      that.fillTable(window.$catalog_users_lastUsedTableFilter, 1);
      // that.reloadData(1);
    }

    window.$catalog_users_refresh = handleRefresh;

    $(".refresh").click(function (e) {
      e.stopPropagation();
      $("#cover-spin").show(0);
      $("#spinner").removeAttr("hidden");
      that.fillTable(window.$catalog_users_lastUsedTableFilter, 1);
      // that.reloadData(1);
    });

    $("div.popup").click(function () {
      var test = this;
      var selectedIds = [];
      $("#example")
        .dataTable()
        .$("tr.selected")
        .each(function () {
          selectedIds.push($(this).attr("rowId"));
        });
      // that.setState({ selectedIds: selectedIds });
      window.$catalog_users_selectedIds = selectedIds;
      that.GetActionsOfRow(selectedIds.join(","));
    });

    $(document).on("click", "#verwijderen", function () {
      if (window.$catalog_users_selectedIds == 0) {
        alert("rows not selected");
      } else {
        $("#management-units-mappen_beheren_delete_modal").modal("show");
      }
    });

    function koppelAanFolderCallBack() {
      GC.sleep(2000).then(() => {
        $("#cover-spin").hide(0);

        $("#modal_koppel_aan_folder").modal("hide");
        that.reloadData(1);
      });
    }

    $(document).on("click", "#management-units-koppel-aan-folder", () => {
      $("#cover-spin").show(0);

      var model = {
        action: "ADD",
        contextRol: "Beheereenheid zit in folder",
        folder: document.getElementById("tree-parent-id").value,
      };
      GC.StartActivity(
        model,
        window.$catalog_users_selectedIds,
        "708371ee-e3f6-4de7-87f8-dfe94b86f9b1",
        koppelAanFolderCallBack(),
        window.$catalog_users_token
      );
    });

    $(document).on("click", ".mm_work_plans_action", function () {
      var actionId = $(this).attr("id");
      let modalId = window.$mm_work_plans_actions.filter(
        (act) => act["id"] === actionId
      )[0]["modal"];
      $("#" + modalId).modal("show");
    });
  }

  render() {
    return (
      <div id="tableSide">
        <table id="example" className="table-hover table min-full-width">
          <thead>
            <tr>
              {this.state.columnList}
              {/* <th className="sorting_disabled" style={{ width: "1%" }}>
                <span className="checkAll" />
                <span className="checkNone" style={{ display: "none" }} />
              </th>
              <th className="sorting_disabled" style={{ width: "1%" }}>
                <img
                  className="icon-table"
                  src={maatregelenSvg}
                  width={18}
                  height={18}
                />
              </th>
              <th>Alias</th>
              <th>Email</th>
              <th>Gebruikersrollen</th>
              <th>Organisatie</th>
              <th>Mandate organisatie</th>
              <th>Geldig van</th> */}
            </tr>
          </thead>
          <tbody></tbody>
        </table>
        <input id="tree-parent-id" hidden />
        <input id="tree-parent-name" hidden />
      </div>
    );
  }
}

export default Table;
